export default __webpack_public_path__ + "static/1275-ebbabe3d7301222b025edbe16f9d6f3f.png";